import comp from "./EventModal";
export default comp;
